
(function ($) {
  const $photographer = $('.field--name-field-photographer');
  const $metaprimary = $('.meta-primary');
  const $storymeta = $('.story-meta');

  if ($storymeta.length != 0 && $photographer.length != 0) {
    $metaprimary.append($photographer);
    $storymeta.addClass('meta-photographer');
  }
})(jQuery);
